import { USER_ID } from "../helpers/constants";
import { AllSameKeyValuesEnforcer, sortByProp } from "../helpers/helpers";
import { TemplateBase } from "./entity.shared.data";
import { BriefType, ItemStatus } from "./share.data";
import { AllSameKeysEnforcer } from '../helpers/helpers';
import { EntityName } from "./entity.data";
import { BrandingData } from "./publish.data";

export interface AssetIcons { audio, construction, gifts, lighting, presentation18, plants, props, scenic, signage, trophy, video, floorplan } 
export const assetIconToName: AllSameKeysEnforcer<AssetIcons> = {
  audio: 'Audio', construction: 'Construction', floorplan: 'Floor plan', gifts: 'Gifts', lighting: 'Lighting', presentation18: 'Presentation', plants: 'Plants and Flowers', props: 'Stage props', scenic: 'Scenic', signage: 'Signage', trophy: 'Awards', video: 'Vision'
}
export const assetIconIds: AllSameKeyValuesEnforcer<AssetIcons> = {
  audio: 'audio', construction: 'construction', floorplan: 'floorplan', gifts: 'gifts', lighting: 'lighting', presentation18: 'presentation18', plants: 'plants', props: 'props', scenic: 'scenic', signage: 'signage', trophy: 'trophy', video: 'video'
}
export const assetIconList = Object.entries(assetIconToName).sort(sortByProp(1)).map(i => i[0])

export interface Asset extends TemplateBase {
  id?: string
  description?: string
  name?: string
  status?: ItemStatus
  labels?: string[]

  link?: string

  associatedId?: string
  submitterType?: EntityName
  submitterId?: string // responsible person for 
  flagged?: boolean
  responsibility?: string
  icon?: string

  entityTypeId?: string // asset category, named entityTypeId to make compatible with entity-types
  
  dueDate?: number
  ready?: boolean
  createdBy?: USER_ID;
  createdType?: "sponsor" | BriefType // only when created by a non user
  createdAt?: number;
  updatedAt?: number;
  updatedBy?: string
  quantity?: number

  logoUrl?: string // fake props for compatibility
  fullLogoUrl?: string  // fake props for compatibility
  showInBudget?: boolean

}

export interface ShareAssetData {
  asset: Asset
  eventTitle: string
  adderName: string
  brandingData: BrandingData
}

export interface ShareAssociatedAssetsData {
  eventTitle: string, 
  entityName: string,
  entityType: "sponsor" | BriefType,
  associatedAssets: Asset[],
  addNew: boolean
  brandingData: BrandingData
}

interface AssetTabs { details, attached, tasks }
export const assetTabs: AllSameKeyValuesEnforcer<AssetTabs> = { details: 'details', attached: 'attached', tasks: 'tasks' }

export const excludedTemplateAssetProps: Set<keyof Asset> = new Set(['status', 'ready', 'dueDate', 'createdBy', 'createdAt', 'updatedAt', 'associatedId', 'labels', 'submitterType', 'submitterId', 'responsibility', 'flagged', 'showInBudget' ])